import { render, staticRenderFns } from "./SocialSecurityNumberInputComponent.vue?vue&type=template&id=16ec65ba&scoped=true&"
import script from "./SocialSecurityNumberInputComponent.vue?vue&type=script&lang=ts&"
export * from "./SocialSecurityNumberInputComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SocialSecurityNumberInputComponent.vue?vue&type=style&index=0&id=16ec65ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ec65ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
